
import { Component, Vue, Watch } from "vue-property-decorator";
import { debounce } from "typescript-debounce-decorator";
import httpClient from "../../store/httpClient";
import { TicketDto } from "@/dtos/ticketDto";
import complainTypes from "@/dtos/IComplainType";
import { TicketState } from "@/dtos/ticketState";
import { IComplainType } from "@/dtos/IComplainType";

@Component({})
export default class CustomerDashboard extends Vue {
	private tickets: TicketDto[] = new Array<TicketDto>();
	private previousSuchbegriff: string = "";
	private suchbegriff: string = "";
	private loading: boolean = false;
	private loadFrom: number = 0;
	private loadBatchSize: number = 25;
	private hasMoreToLoad: boolean = true;
	private headers: Array<{
		width: string;
		text: string;
		value: string;
		align: string;
		sortable: boolean;
	}> = Array(
		{
			width: "1%",
			text: "Aktion",
			value: "icon",
			align: "center",
			sortable: false,
		},
		{
			width: "1%",
			text: "Id",
			value: "id",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Auftrag Id",
			value: "orderId",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Kunden Id",
			value: "customerId",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Kunde",
			value: "customerName",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Fertiger",
			value: "manufacturerName",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Neuer Liefertermin",
			value: "deliveryDate",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Erstellt am",
			value: "createdAt",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Verarbeiten",
			value: "edit",
			align: "left",
			sortable: false,
		}
	);

	private complaintsHeader: Array<{
		width: string;
		text: string;
		value: string;
		align: string;
		sortable: boolean;
	}> = Array(
		{
			width: "1%",
			text: "Pos",
			value: "position",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Part Id",
			value: "part.articleId",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Beschwerde Typ",
			value: "complainType",
			align: "left",
			sortable: false,
		},
		{
			width: "1%",
			text: "Bild",
			value: "image",
			align: "left",
			sortable: false,
		}
	);

	private complaintTypeEnum: IComplainType[] = complainTypes;

	beforeRouteEnter(to: any, from: any, next: any) {
		next((vm: any) => {
			window.addEventListener("scroll", vm.checkBottom);
		});
	}

	beforeRouteLeave(to: any, from: any, next: any) {
		window.removeEventListener("scroll", this.checkBottom);
		next();
	}

	private mounted() {
		this.loadTickets(true);
	}

	@debounce(700, { leading: false })
	@Watch("suchbegriff")
	private reloadOnOrderSearch() {
		if (
			(this.suchbegriff.length === 0 || this.suchbegriff.length >= 3) &&
			this.suchbegriff !== this.previousSuchbegriff
		) {
			this.previousSuchbegriff = this.suchbegriff;
			this.loadTickets(true);
		}
	}

	private checkBottom() {
		let bottomOfWindow =
			window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
		if (bottomOfWindow && this.hasMoreToLoad && !this.loading && this.showResolved) {
			this.loadTickets(false);
		}
	}

	private manuallyLoadMoreTickets() {
		if (this.hasMoreToLoad && !this.loading) {
			this.loadTickets(false);
		}
	}

	private customSort(items: any, index: any, isDesc: any) {
		// Do nothing because items are correclty sorted by the backend
		// But a custom sort is needed because otherwise the data-table shuffles items around
		// Maybe there is another solution to stop the sorting but I haven't found it, yet.
		return items;
	}

	private get showResolved() {
		return this.$store.state.ticketSettings.showResolved;
	}
	private set showResolved(showResolved: boolean) {
		this.$store.commit("setShowResolved", showResolved);
		this.loadTickets(true);
	}

	private waitingForBlexon(ticket: TicketDto) {
		return ticket.state == TicketState.Open && ticket.manufacturerHasDecided;
	}

	private waitingForFertiger(ticket: TicketDto) {
		return ticket.state == TicketState.Open && !ticket.manufacturerHasDecided;
	}

	private isDatePresent(date: Date) {
		const deliveryDate: Date = new Date(date);
		const minDate: Date = new Date(1900, 1, 1);
		return deliveryDate > minDate;
	}

	private async loadTickets(reload: boolean) {
		if (this.loading) return;
		try {
			this.loading = true;
			if (reload) {
				this.loadFrom = 0;
				this.tickets = new Array<TicketDto>();
			}
			const response = await httpClient().get(
				`Ticket/GetAllOpenTickets?searchTerm=${this.suchbegriff}` +
					`&onlyOpen=${!this.showResolved}&from=${this.loadFrom}&to=${this.loadFrom + this.loadBatchSize}`
			);
			this.tickets.push(...response.data);
			this.loadFrom += this.loadBatchSize;
			this.hasMoreToLoad = response.data.length === this.loadBatchSize;
		} catch {
			console.log("Load tickets failed.");
		} finally {
			this.loading = false;
		}
	}

	private processTicket(ticketId: string) {
		this.$router.push({ name: "processTicket", params: { ticketId } });
	}

	private getThumbnailUrl(articleId: string) {
		return (
			process.env.VUE_APP_erpUrl +
			`article/getthumbnail?id=${articleId}&time=${Date.now().toString()}`
		);
	}
}
